let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1unpt")).then(() => parcelRequire('f8LQ8'));